import { numberInputAnatomy as s } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as d } from "@chakra-ui/react";
import e from "./input.mjs";
const { defineMultiStyleConfig: p, definePartsStyle: a } = d(s.keys);
var t;
const f = a({
  field: {
    ...(t = e.baseStyle) == null ? void 0 : t.field
  },
  stepperGroup: {
    flexDirection: "row",
    color: "teal.500"
  },
  stepper: {
    borderStart: "1px solid",
    borderStartColor: "gray.200",
    _last: {
      pb: "4px",
      borderRightRadius: "lg"
    },
    _active: {
      bg: "gray.200"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  }
});
var i, r, l, o;
const b = p({
  baseStyle: f,
  sizes: {
    md: {
      field: (i = e.sizes) == null ? void 0 : i.md.field,
      stepperGroup: {
        width: "80px",
        fontSize: "12px"
      }
    },
    sm: {
      field: (r = e.sizes) == null ? void 0 : r.sm.field,
      stepperGroup: {
        width: "64px",
        fontSize: "10px"
      }
    }
  },
  variants: {
    outline: {
      field: (l = e.variants) == null ? void 0 : l.outline.field
    },
    filled: {
      field: (o = e.variants) == null ? void 0 : o.filled.field
    }
  },
  defaultProps: e.defaultProps
});
export {
  b as default
};
